<mat-form-field appearance="outline" class="phone-height" floatLabel="always" [class.mat-form-field-readonly]="readonly" [class.ng-valid]="errors === ''"  [id]="idPrefix + '-form-field'">
  <mat-label [id]="idPrefix + '-label'">{{label}}</mat-label>
  <input lcTestId matInput type="text" [dropSpecialCharacters]="maskDropSpecialCharacters" [errorStateMatcher]="matcher" [formControl]="formControl" [id]="idPrefix + '-input'" [mask]="inputMask?.mask" [patterns]="inputMask?.pattern" [placeholder]="placeholder" [readonly]="readonly" (blur)="onBlur()">
  <mat-hint [id]="idPrefix + '-hint'">{{hint}}</mat-hint>
  @if (formControl && formControl.invalid) {
    <mat-error class="row" [id]="idPrefix + '-error'" [innerHTML]="errors" />
  }
</mat-form-field>
